import theme from '../js/theme';

export const isMobileScreen = (width) => width < theme.breakpoint.l.value;
